import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from './locales/eng.json';
import translationCHT from './locales/cht.json';
import translationCHS from './locales/chs.json';

var langDict = {
  "en": "EN",
  "cht": "CHT",
  "chs": "CHS"
};

let search = window.location.search;
let params = new URLSearchParams(search);
let deviceLang = window.navigator.systemLanguage || window.navigator.language;
let lang = "";

if (langDict[params.get("l")]) {
  lang = langDict[params.get("l")] ? langDict[params.get("l")] : "CHT";
} else if (deviceLang.toLowerCase()) {
  if (deviceLang.toLowerCase() === "zh-tw" || deviceLang.toLowerCase() === "zh-hk") {
    lang = "CHT";
  } else {
    lang = "EN";
  }
} else {
  lang = "EN";
}

// the translations
const resources = {
  EN: {
    translation: translationEN
  },
  CHT: {
    translation: translationCHT
  },
  CHS: {
    translation: translationCHS
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: lang,
    fallbackLng: "CHT",
    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;